import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { Root, Slider } from './Slider.styles.js';
import { FadeIn } from '../../../Animations/FadeIn/FadeIn.js';
import { VARIANTS as VARIANTS$1, MAX, MIN, STEP, NO_OP } from '../constants.js';
import useSliderScaleFactor from './useSliderScaleFactor.js';
import ScreenReaderOnly from '../../../ScreenReaderOnly/index.js';
import Rail from './Rail.js';
import RangeSelection from './RangeSelection.js';

var VARIANTS = Object.values(VARIANTS$1);
var SliderSingle = function SliderSingle(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? undefined : _ref$id,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? MAX : _ref$max,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? MIN : _ref$min,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? NO_OP : _ref$onChange,
    _ref$onChangeComplete = _ref.onChangeComplete,
    onChangeComplete = _ref$onChangeComplete === void 0 ? NO_OP : _ref$onChangeComplete,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? STEP : _ref$step,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? VARIANTS$1.LESS_THAN : _ref$variant;
  var _useSliderScaleFactor = useSliderScaleFactor({
      max: max,
      min: min
    }),
    _useSliderScaleFactor2 = _slicedToArray(_useSliderScaleFactor, 2),
    ref = _useSliderScaleFactor2[0],
    scaleFactor = _useSliderScaleFactor2[1];
  var handleChange = function handleChange(e) {
    onChange(e, +e.currentTarget.value);
  };
  var handleChangeComplete = function handleChangeComplete(e) {
    onChangeComplete(e, +e.currentTarget.value);
  };
  return React__default.createElement(Root, {
    $disabled: isDisabled,
    ref: ref
  }, React__default.createElement(FadeIn, null, React__default.createElement(Rail, null), variant !== VARIANTS$1.FLOATING && React__default.createElement(RangeSelection, {
    max: max,
    min: min,
    scaleFactor: scaleFactor,
    value: variant === VARIANTS$1.LESS_THAN && [min, value] || variant === VARIANTS$1.GREATER_THAN && [value, max]
  }), React__default.createElement(ScreenReaderOnly, {
    as: "label",
    htmlFor: id && "".concat(id)
  }, value), React__default.createElement(Slider, {
    "data-testid": testId,
    disabled: isDisabled,
    id: id,
    max: max,
    min: min,
    onBlur: handleChangeComplete,
    onChange: handleChange,
    onMouseUp: handleChangeComplete,
    onKeyUp: handleChangeComplete,
    onTouchEnd: handleChangeComplete,
    step: step,
    type: "range",
    value: value
  })));
};
SliderSingle.propTypes = {
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  onChangeComplete: PropTypes.func,
  step: PropTypes.number,
  testId: PropTypes.string,
  value: PropTypes.number,
  variant: PropTypes.oneOf(VARIANTS)
};
var SliderSingle$1 = SliderSingle;

export { SliderSingle$1 as default };
//# sourceMappingURL=SliderSingle.js.map
